__turbopack_context__.v({
  "card": "card-module__h6QB_G__card",
  "description": "card-module__h6QB_G__description",
  "header": "card-module__h6QB_G__header",
  "title": "card-module__h6QB_G__title",
});
